import {
  Button,
  Checkbox,
  Divider,
  Dropdown,
  MenuProps,
  Select,
  Space,
  Table,
  Typography,
} from 'antd';
import { ColumnsType } from 'antd/lib/table';
import GeneralHeader from 'components/common/GeneralHeader';
import useAuth from 'hooks/useAuth';
import { ParsedUrlQuery, encode } from 'querystring';
import { useState } from 'react';
import { useCookies } from 'react-cookie';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { EmployeeUsersProps, GET, POST, PUT } from 'utils';
import { api } from 'utils/apiRoutes';
import NESTEDROUTE from 'utils/router';
const { Text } = Typography;
type TemployeeUser = {
  fullName: string;
  email: string;
  adminNumber: string;
  jobTitle: string;
  department: string;
  userProfile: string;
  staffLeaveProfile: string;
  employeeContract: string;
  contractStart: string;
  contractEnd: string;
  contractStartReason: string;
  contractEndReason: string;
  proStatus: string;
  manager: string;
  action?: string;
};
const Accounts = () => {
  const [state, setState] = useState({
    searchString: '',
    deleteID: [],
    userArchiveChoice: '',
  });
  const { searchString, deleteID, userArchiveChoice } = state;
  const navigate = useNavigate();
  const { user } = useAuth();
  const [cookies, setCookies] = useCookies(['access_token', 'refresh_token']);
  async function getListEmployee(query?: ParsedUrlQuery) {
    return await GET(`/api/users/employee/?${encode(query)}`);
  }

  const { data, refetch } = useQuery({
    queryKey: ['get-list-employee', userArchiveChoice],
    queryFn: () => {
      if (userArchiveChoice === '') {
        return getListEmployee({});
      }
      if (userArchiveChoice === 'User Archive') {
        return getListEmployee({ is_archived: 'true' });
      }
      if (userArchiveChoice === 'User Active') {
        return getListEmployee({ is_archived: 'false', is_undefined: 'false' });
      }
      if (userArchiveChoice === 'Undefited Active') {
        return getListEmployee({ is_archived: 'false', is_undefined: 'true' });
      }
    },
  });
  //   console.log(data)

  const keysRow = [
    'fullName',
    'email',
    'adminNumber',
    'jobTitle',
    'department',
    'userProfile',
    'staffLeaveProfile',
    'employeeContract',
    'contractStart',
    'contractEnd',
    'contractStartReason',
    'contractEndReason',
    'proStatus',
    'manager',
  ];
  const userArchive = [
    {
      label: 'User Archive',
      value: 'User Archive',
    },
    {
      label: 'User Active',
      value: 'User Active',
    },
    {
      label: 'Undefited Active',
      value: 'Undefited Active',
    },
  ];
  const items: MenuProps['items'] = [
    {
      icon: (
        <img
          src={'/icons/login_user.svg'}
          alt={'login'}
          width={20}
          height={20}
        />
      ),
      key: '1',
      label: 'Sign in under user this account',
    },
    {
      key: '2',
      label: 'Archive',
      icon: (
        <img
          src={'/icons/delete_icon.svg'}
          alt={'login'}
          width={20}
          height={20}
        />
      ),
    },
    {
      key: '3',
      label: 'Open work shift calendar',
      icon: (
        <img src={'/icons/calendar.svg'} alt={'login'} width={20} height={20} />
      ),
    },
    {
      key: '4',
      label: 'Open user profile',
      icon: (
        <img
          src={'/icons/persona_icon.svg'}
          alt={'login'}
          width={20}
          height={20}
        />
      ),
    },
    {
      key: '5',
      label: 'Open staff leave profile',
      icon: (
        <img
          src={'/icons/staff_icon.svg'}
          alt={'login'}
          width={20}
          height={20}
        />
      ),
    },
    {
      icon: (
        <img
          src={'/icons/clock_icon.svg'}
          alt={'login'}
          width={20}
          height={20}
        />
      ),
      key: '6',
      label: ' Open the time & activities profile',
    },
  ];

  async function loginAsOtherUser(id: number) {
    await POST(api.forceLogin, { user_id: id }).then((res) => {
      if (res.status === 200) {
        setCookies('access_token', res.data.access);
        setCookies('refresh_token', res.data.refresh);
        window.location.href = '/';
      }
    });
  }
  const deleteUser = async function (id: number | number[]) {
    // const res = await DELETE(`${api.deleteUser}/?ids=${id}`);
    const res = await PUT(`${api.archiveUser}/?ids=${id}`);
    if (res.status === 204) {
      refetch();
    }
    console.log(id);
  };

  const employeeData = data?.data
    ?.filter((item: EmployeeUsersProps) =>
      keysRow.some((key) =>
        item[key]?.toString()?.trim()?.toLowerCase().includes(searchString),
      ),
    )
    .map((item: any, index: number) => {
      return {
        action: (
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Checkbox
              onChange={(e) => {
                if (e.target.checked) {
                  setState((p) => ({
                    ...p,
                    deleteID: [...deleteID, e.target.value],
                  }));
                } else {
                  setState((p) => ({
                    ...p,
                    deleteID: [...deleteID].filter(
                      (item) => item !== e.target.value,
                    ),
                  }));
                }
              }}
              value={item.id}
              disabled={item.id === user.id}
            />
            <Dropdown
              menu={{
                items,
                onClick: (e) =>
                  e.key === '1'
                    ? user.id === item.id
                      ? null
                      : loginAsOtherUser(item.id)
                    : e.key === '2'
                    ? user.id === item.id
                      ? null
                      : deleteUser(item.id)
                    : e.key === '3'
                    ? navigate(`/workshift_calendar/${item.workshift[0].id}`)
                    : e.key === '4'
                    ? navigate(NESTEDROUTE.personal_data, {
                        state: { id: item.id },
                      })
                    : e.key === '5'
                    ? navigate(`/leave_profile/${item.absence_policy.id}`)
                    : console.warn('%c in progress...', 'color:red'),
              }}
              placement={'topLeft'}
            >
              <Button
                type={'text'}
                icon={
                  <img
                    src={'/icons/3_dots.svg'}
                    alt={'icon'}
                    width={18}
                    height={18}
                  />
                }
              />
            </Dropdown>
          </div>
        ),
        fullName: item.fullName,
        email: item.email,
        adminNumber: item.id,
        jobTitle: item.job_title,
        department: item.department__name,
        managers: item?.manager?.map((manager) => {
          return { managerName: manager.first_name + ' ' + manager.last_name };
        }),
        userProfile: item?.role,
        staffLeaveProfile: item?.absence_policy__name,
        employeeContract: item?.contract__employment_contract,
        contractStart: item?.contract__contract_start_date,
        contractEnd: item?.contract__contract_end_date,
        contractStartReason: item?.contract__contract_start_reason,
        contractEndReason: item?.contract__contract_end_reason,
        proStatus: item?.contract__professional_status,
      };
    });

  const tableHeadRow: ColumnsType<TemployeeUser> = [
    {
      title: (
        <Button
          type={'text'}
          onClick={() => deleteUser(deleteID)}
          disabled={deleteID.length === 0}
        >
          Action{' '}
          <img
            src="/icons/delete_icon.svg"
            alt="icon"
            width={16}
            height={16}
            style={{ marginLeft: '10px' }}
          />
        </Button>
      ),
      key: 'action',
      dataIndex: 'action',
    },
    {
      title: 'Employee',
      key: 'employee',
      dataIndex: 'fullName',
    },
    {
      title: 'Email Address',
      key: 'email',
      dataIndex: 'email',
    },
    {
      title: 'Administrative number',
      key: 'admin_number',
      dataIndex: 'adminNumber',
      width: 180,
    },
    {
      title: 'Job title',
      key: 'job',
      dataIndex: 'jobTitle',
      align: 'center',
    },
    {
      title: 'Department',
      key: 'department',
      dataIndex: 'department',

      align: 'center',
    },
    {
      title: 'Manager',
      key: 'manager',
      dataIndex: 'manager',
      render: (manager) => (
        <p>
          {manager?.map((item: { managerName: string }) => item.managerName)}
        </p>
      ),
    },
    {
      title: 'User Profile',
      key: 'profile',
      dataIndex: 'userProfile',
    },
    {
      title: 'Staff Leave Profile',
      key: 'staffLeaveProfile',
      dataIndex: 'staffLeaveProfile',
    },
    {
      title: 'Employee Contract',
      key: 'employee_contract',
      dataIndex: 'employeeContract',
    },
    {
      title: 'Contract Start Date',
      key: 'contract_start',
      dataIndex: 'contractStart',
    },
    {
      title: 'Contract End Date',
      key: 'contract_end',
      dataIndex: 'contractEnd',
    },
    {
      title: 'Contract Start Reason',
      key: 'contract_reason1',
      dataIndex: 'contractStartReason',
    },
    {
      title: 'Contract End Reason',
      key: 'contract_reason2',
      dataIndex: 'contractEndReason',
    },
    {
      title: 'Professional status',
      key: 'pro_status',
      dataIndex: 'proStatus',
    },
  ];

  return (
    <GeneralHeader
      icon={'/icons/ic_employee.svg'}
      pageTitle={'Accounts'}
      child={
        <div style={{ marginTop: '100px' }}>
          {/*
          <Button
            icon={<img src={'/icons/arrow_select.svg'} alt={'icon'} />}
            type={'text'}
          >
            Filters
          </Button>

          <div style={{ marginBottom: '30px' }}>
            <div className="employee_users_wrapper">
              <div style={{ width: '33%' }}>
                <CustomDropdown title="Department" options={filterDepartment} />
              </div>
              <div style={{ width: '33%' }}>
                <CustomDropdown title="Employee" options={mrs} />
              </div>
              <div style={{ width: '33%' }}>
                <CustomDropdown title="Display Employees" options={mrs} />
              </div>
            </div>
            <div className="employee_users_wrapper">
              <div style={{ width: '25%' }}>
                <CustomDropdown title="Work Shift" options={mrs} />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDropdown title="User Profile" options={mrs} />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDropdown
                  title="Staff Leave/Absence Profile"
                  options={mrs}
                />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDropdown title="Expense report profile" options={mrs} />
              </div>
            </div>
            <div className="employee_users_wrapper">
              <div style={{ width: '25%' }}>
                <CustomDropdown
                  title="Time & Activities Profile"
                  options={mrs}
                />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDropdown title="Employment Contract" options={mrs} />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDropdown title="Contract Start Reason" options={mrs} />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDropdown title="Contract End Reason" options={mrs} />
              </div>
            </div>
            <div className="employee_users_wrapper">
              <div style={{ width: '33%' }}>
                <CustomDropdown title="Professional Status" options={mrs} />
              </div>
              <div style={{ width: '33%' }}>
                <CustomDropdown title="Activity Type" options={mrs} />
              </div>
              <div style={{ width: '33%' }}>
                <CustomDropdown title="Working Time Unit" options={mrs} />
              </div>
            </div>
            <div className="employee_users_wrapper">
              <div style={{ width: '25%' }}>
                <CustomDropdown title="Contract Start Date" options={mrs} />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDropdown title="Contract End Date" options={mrs} />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDropdown title="Creation Date" options={mrs} />
              </div>
              <div style={{ width: '25%' }}>
                <CustomDatePicker title="List of employees to date" />
              </div>
            </div>
            <button className="employee_users_button">Confirm</button>
          </div>
*/}

          <div
            style={{
              overflowX: 'auto',
              width: '100%',
              height: 'auto',
            }}
            className="employeeuser_table"
          >
            <Space
              size={'middle'}
              style={{ margin: '18px 16px', position: 'sticky', top: 0 }}
            >
              <img src="/icons/my_request_settings.svg" alt="settings" />
              {/* <Text style={{ fontSize: 14 }}>{employeeData?.length} items</Text>
              <Text style={{ fontSize: 16, fontWeight: 600 }}>
                Employee & Users
              </Text>
              <Input
                suffix={<SearchOutlined />}
                placeholder={'Insert employee name'}
                onChange={(e) =>
                  setState((p) => ({
                    ...p,
                    searchString: e.target.value.toLowerCase(),
                  }))
                }
              /> */}
              <Select
                style={{ width: '150px' }}
                suffixIcon={<img src="/icons/arrow_select.svg" alt="arrow" />}
                onChange={(e: string) => {
                  setState((pre) => ({
                    ...pre,
                    userArchiveChoice: e,
                  }));
                }}
              >
                {userArchive?.map((item: any, index: number) => (
                  <option key={index} value={item?.value} label={item?.label}>
                    <Space>{item?.label}</Space>
                  </option>
                ))}
              </Select>
            </Space>
            <Divider style={{ background: '#73A1E7', margin: 0 }} />
            {employeeData && (
              <Table
                columns={tableHeadRow}
                scroll={{ y: 361 }}
                style={{ width: '100%' }}
                dataSource={employeeData}
                size={'middle'}
              />
            )}
          </div>
        </div>
      }
    />
  );
};

export default Accounts;
